module.exports = __webpack_public_path__ + "static/img/premio2022.a623556.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente/premio2022.jpg
// module id = BSnh
// module chunks = 0